var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fieldset"},[_c('label',[_vm._v("服務類型")]),_c('select',{attrs:{"name":"storeType","disabled":_vm.disabled}},_vm._l((_vm.source),function(item,index){return _c('option',{key:index,domProps:{"value":item.type}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }